import { useChatStream } from "@/features/chat/hooks/useChatStream";
import { AGENT_CONFIG_PATH } from "@/features/chat/types";
import { useCallback } from "react";

/** Send a message in a curation's chat, the same as typing it in the chat panel. */
export const useCurationAgentMessage = (sessionId: string | null | undefined) => {
  const { sendMessage } = useChatStream(sessionId ?? undefined, {
    agentConfigPath: AGENT_CONFIG_PATH,
    dataCurationChat: true,
  });
  return useCallback(
    (message: string) => {
      if (sessionId) void sendMessage(message);
    },
    [sendMessage, sessionId],
  );
};
